import { Dialog } from "primereact/dialog";
import { UnAssignModalProps } from "../types/tenants";
import UnassignIcon from "~/assets/unassign-icon.svg";
import "./tenantModals.scss";
import CustomeButton from "~/components/Button";

const UnassignModal = ({
  visible,
  closeModal,
  toastRef,
  unAssignHandler,
  loading,
  title,
  description,
  actionBtnlabel,
}: UnAssignModalProps) => {
  const footerTemplate = () => {
    return (
      <div className="flex justify-content-center gap-2">
        <CustomeButton
          label="Cancel"
          variant="outlined"
          className="cancel-button"
          onClick={closeModal}
        />
        <CustomeButton
          label={actionBtnlabel}
          variant="remove"
          className="unassign-button"
          onClick={unAssignHandler}
          disabled={loading}
          loading={loading}
        />
      </div>
    );
  };
  return (
    <Dialog
      visible={visible}
      style={{ width: "930px" }}
      onHide={closeModal}
      className="unassign-user-modal"
      footer={footerTemplate}
    >
      <div className="flex flex-column gap-3 align-items-center">
        <img src={UnassignIcon} alt="Unassign User" className="unassign-icon" />
        <div className="flex flex-column gap-1 content">
          <div className="title m-0">{title}</div>
          <div className="description m-0">{description}</div>
        </div>
      </div>
    </Dialog>
  );
};

export default UnassignModal;
